import React from 'react';
import CRUDSection from '../CRUDSection';

function Events() {
  const config = {
    title: 'Event',
    tableColumns: ['Image (Logo)', 'Title', 'Link', 'Actions'],
    renderForm: (formData, handleInputChange, handleImageChange, isEditing) => (
      <>
        <div className="form-grid">
          <div className="form-group">
            <label>Title *</label>
            <input
              type="text"
              name="title"
              value={formData.title || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Link (optional)</label>
            <input
              type="url"
              name="link"
              value={formData.link || ''}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="form-grid full">
          <div className="form-group">
            <label>Image (Logo) *</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required={!isEditing}
            />
            <small>Leave blank to keep existing image when updating</small>
          </div>
        </div>
      </>
    ),
    renderRow: (item, handleEdit, handleDelete) => (
      <>
        <td>
          <img src={item.imageUrl} alt={item.title} />
        </td>
        <td>{item.title}</td>
        <td>
          {item.link ? (
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              View
            </a>
          ) : (
            'N/A'
          )}
        </td>
        <td className="table-actions">
          <button className="btn-edit" onClick={() => handleEdit(item)}>
            Edit
          </button>
          <button className="btn-delete" onClick={() => handleDelete(item.id)}>
            Delete
          </button>
        </td>
      </>
    )
  };

  return <CRUDSection category="events" config={config} />;
}

export default Events;
